"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function Minus() {
  return _react.default.createElement("svg", {
    viewBox: "0 0 20 20"
  }, _react.default.createElement("path", {
    stroke: "#242523",
    strokeWidth: "2",
    d: "M0 1h18"
  }));
}

var _default = Minus;
exports.default = _default;